export default "__VITE_ASSET__CmFjUMk$__"